import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { IEditField } from './formTools';
import { EditPersonDisplay, EditPersonField } from './EditPerson';

export const EditTeammateDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task, setIsEditing }) => (
  <EditPersonDisplay task={task} setIsEditing={setIsEditing} fullName={task.teammate?.fullName} />
);

export const EditTeammateField: React.FC<IEditField> = ({ submitOnChange, cancel }) => (
  <EditPersonField submitOnChange={submitOnChange} fieldName={'teammate'} cancel={cancel} />
);
